import React from "react";
import { useHistory } from "react-router-dom";
import { BreadcrumbItem, Breadcrumb } from "sprint-common-web";

import { assetsSearchRoutes, tvSeriesAssetsSearchRoute } from "../../AssetsRoutes";

interface TvSeriesAssetsListBreadcrumbsProps {
    tvSeriesName?: string;
    isLoading: boolean;
}

export const TvSeriesAssetsListBreadcrumbs: React.FunctionComponent<TvSeriesAssetsListBreadcrumbsProps> = (
    props: TvSeriesAssetsListBreadcrumbsProps
) => {
    const history = useHistory();

    const { tvSeriesName, isLoading } = props;

    const goToAssetsSearchPage = () => {
        history.push(tvSeriesAssetsSearchRoute.path);
    };

    const items: BreadcrumbItem[] = [
        ...assetsSearchRoutes.baseRouteNames.map((name: string) => {
            return { key: name, text: name };
        }),
        {
            key: "search-breadcrumb",
            text: tvSeriesAssetsSearchRoute.name,
            onClick: goToAssetsSearchPage
        },
        {
            key: "tv-series-name-breadcrumb",
            text: tvSeriesName || ""
        }
    ];

    return <Breadcrumb items={items} isLoading={isLoading} />;
};
